'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconTablet, iconTabletTag } from '@ni/nimble-components/dist/esm/icons/tablet';
import { wrap } from '../../utilities/react-wrapper';

export type { IconTablet };
export { iconTabletTag };
export const NimbleIconTablet = wrap(IconTablet);